import axiosInstance from '../api/api';
import { API_ROUTES } from '../config/api-routes';
import { getUserFacingError } from './userFacingError';

type ResendReferenceResponse = {
  detail?: string;
  verificationUrl?: string;
};

export async function resendReferenceVerificationEmail(referenceId: number): Promise<string> {
  const response = await axiosInstance.post<ResendReferenceResponse>(
    `${API_ROUTES.REFERENCE.RESEND_CONFIRMATION_EMAIL}?referenceId=${referenceId}`,
    undefined,
    { suppressErrorToast: true }
  );
  const detail = response.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  return 'We sent another verification email to your reference.';
}

/** Generate a fresh verification link without sending email (for copy-to-clipboard). */
export async function fetchReferenceVerificationLink(referenceId: number): Promise<string> {
  const response = await axiosInstance.post<ResendReferenceResponse>(
    `${API_ROUTES.REFERENCE.RESEND_CONFIRMATION_EMAIL}?referenceId=${referenceId}&linkOnly=1`,
    undefined,
    { suppressErrorToast: true }
  );
  const url = response.data?.verificationUrl;
  if (typeof url === 'string' && url.trim()) return url.trim();
  throw new Error('Verification link is not available.');
}

export function referenceResendError(err: unknown): string {
  return getUserFacingError(
    err,
    'We could not resend the verification email. Please try again in a moment.'
  );
}
